// eslint-disable-next-line import/prefer-default-export
export const whatsAppShare = message => {
  const textMessage = encodeURI(message);
  return `https://api.whatsapp.com/send?text=${textMessage}`;
};
